//components
import CityItem from './city-item';

const ActiveCity = ({
        city,
        setCityWithRegion 
    }:{
        city: string,
        setCityWithRegion: (city: string, region: string) => void
    }
) => {
    return (
        <div className="cities-filter-list__column">
            <CityItem
                city={city}
                isActive={true}
                setCityHandler={() => setCityWithRegion('', '')}
            />
        </div>
    );
}

export default ActiveCity;